<template>
  <v-flex
    xs12
    md10
    offset-md1
    align-self-center
    justify-center
  >
    <v-row>
        <v-col
          cols="8"
        >
          <AutoComplete
          :value="searchBook"
          v-model="searchBook"
          key-value="id"
          key-name="fulltext"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="books"
          :label="$t('fields.book')"
          @search="searchBooks"
          @input="fetchBooksIfExist"
          @clear="deleteSelectedBooks"
          :delay="900"
          :errors="errors"
        >
        </AutoComplete>
        </v-col>
    </v-row>
    <v-card flat light>
      <v-data-table
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :no-data-text="$t('NO_DATA')"
        :no-results-text="$t('NO_DATA')"
        hide-default-footer
        :options.sync="pagination"
        :loading="loading || loadingReport"
        class="elevation-1"
      >

        <template v-slot:[`item.counter_section`]="{ item }">
            {{ item.counter_section }}
        </template>

        <template v-slot:[`item.counter_new`]="{ item }">
            {{ item.counter_new }}
        </template>

        <!-- Add a footer -->
        <template v-slot:body.append v-if="items.length">
        <tr>
          <td></td>
          <td></td>
          <td>Total <b>{{ sumCounterSection }}</b></td>
          <td>Total <b>{{ sumCounterNew }}</b></td>
        </tr>
      </template>
      </v-data-table>
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchReport"
      />
    </v-card>
  </v-flex>
</template>
<script>

import { adoptionsService } from '../../../utils/services/adoptions.service';
import { booksService } from '../../../utils/services/books.service';
import AutoComplete from '../../../components/shared/Inputs/AutoComplete.vue';
import Paginator from '../../../components/shared/Paginator';

export default {
  name: 'AdoptionReportPropagandistBook',
  components: { AutoComplete, Paginator },
  data() {
      return {
        loading: false,
        loadingReport: false,
        items: [],
        totalItems: 0,
        searchBook: null,
        book: {},
        books: [],
        totalCounterNew: 0,
        totalCounterSection: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['propagandist'],
        },
        headers: [
          { text: this.$t('fields.isbn'), value: 'isbn', sortable: false },
          { text: this.$t('fields.propagandist'), value: 'propagandist' },
          { text: this.$t('fields.section'), value: 'counter_section' },
          { text: this.$t('fields.is_new'), value: 'counter_new' },
        ],
        filters: {
          bookId: null,
          searchBook: null,
        },
      };
    },

    computed: {
      sumCounterNew() {
        return this.items.reduce((sum, row) => sum + row.counter_new, 0);
      },
      sumCounterSection() {
        return this.items.reduce((sum, row) => sum + row.counter_section, 0);
      },

      requestFilters() {
        const filters = {
          bookId: this.filters.bookId,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },

    methods: {
      sumCounterNew(value) {
        this.totalCounterNew += value;
      },
      sumCounterSection(value) {
        this.totalCounterSection += value;
      },
      deleteSelectedBooks() {
        this.book = {};
        this.filters.bookId = null;
      },

      async searchBooks(val) {
        this.filters.searchBook = val;
        await this.fetchBooks();
      },

      async fetchBooksIfExist(id) {
        if (id > 0) {
          this.filters.bookId = id;
          await this.fetchBook(id);
        } else {
          this.filters.bookId = 0;
        }
      },

      async fetchBooks() {
        this.loading = true;
        return booksService.index({
          filters: {
            search: this.filters.searchBook,
          },
        })
        .then(response => {
            this.books = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchBook(id) {
        this.loading = true;
        return booksService.get(id)
        .then(response => {
            this.book = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchReport(forcePage) {
        console.log(Date.now());
        this.loadingReport = true;
        const { page, itemsPerPage } = this.pagination;
        return adoptionsService.reportPropagandistBook({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        },
          )
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.total;
            this.pagination = this.getPagination(
              response.data,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
              this.handleError(error, this.errors);
          }).finally(() => {
            this.loadingReport = false;
            console.log(Date.now());
          });
      },
    },
    watch: {
      'filters.bookId': {
        async handler(newVal, oldVal) {
          if (newVal > 0) {
              await this.fetchReport(1);
            } else {
              this.items = [];
              this.totalItems = 0;
              this.pagination.page = 1;
            }
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchReport(1);
          }
        },
      },
    },
};
</script>
